import { CircleExclamationIcon } from '@lower-financial/icons';
import { ComponentProps, ReactNode } from 'react';
import { Button } from '../button';
import { HeadingColors } from '../heading';
import { StandardModal } from './standard-modal';

type StandardModalProps = ComponentProps<typeof StandardModal>;

type Props = Pick<StandardModalProps, 'onCloseModal' | 'isOpen' | 'fitContent'> & {
  errorTitle: string;
  errorDescription: string;
  actionNeededToResolveError: string;
  children?: ReactNode|ReactNode[];
};

export const ErrorModal = ({
  errorTitle,
  errorDescription,
  actionNeededToResolveError,
  children,
  ...standardModalProps
}: Props) => (
  <StandardModal
    {...standardModalProps}
    heading={errorTitle}
    headingColor={HeadingColors.Error}
    subheading={[errorDescription.trim(), actionNeededToResolveError.trim()].join(' ')}
    icon={(
      <CircleExclamationIcon
        color={'var(--error)'}
        label={'error icon'}
      />
    )}
    footer={<Button onClick={standardModalProps.onCloseModal}>Dismiss</Button>}
  >
    {children}
  </StandardModal>
);
